import React, { useState } from "react";
import { Wallet, ArrowLeft, Send, Loader } from "lucide-react";
import { useAuth } from "./AuthContext";

const BACKEND_URL = process.env.REACT_APP_API_BASE_URL;

const ContactPage = ({ onBack }) => {
  const { getToken } = useAuth();
  const [form, setForm] = useState({
    name: "",
    email: "",
    category: "一般的な質問",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState("");

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.message) {
      alert("名前・メールアドレス・お問い合わせ内容は必須です");
      return;
    }
    setSending(true);
    setResult("");
    try {
      const token = await getToken();
      const res = await fetch(`${BACKEND_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(form),
      });
      const json = await res.json();
      if (json.success) {
        setResult("送信しました。お問い合わせありがとうございます。");
        setForm({ name: "", email: "", category: "一般的な質問", message: "" });
      } else {
        setResult("送信に失敗しました。時間をおいて再度お試しください。");
      }
    } catch (e) {
      console.error("送信エラー:", e);
      setResult("送信に失敗しました。");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-page text-color font-sans">
      <header className="sticky top-0 z-50 backdrop-blur-xl border-b border-theme"
        style={{ backgroundColor: "var(--color-bg)", opacity: 0.97 }}>
        <div className="max-w-[800px] mx-auto px-5 py-3.5 flex justify-between items-center">
          <div className="flex items-center gap-2.5">
            <div className="p-2 rounded-xl flex items-center justify-center"
              style={{ background: "linear-gradient(135deg, var(--color-accent), var(--color-accent-soft))" }}>
              <Wallet size={22} color="#fff" />
            </div>
            <span className="text-xl font-bold tracking-tight text-color">お問い合わせ</span>
          </div>
          <button onClick={onBack}
            className="flex items-center gap-1.5 text-sm text-accent hover:opacity-80 bg-transparent border-none cursor-pointer">
            <ArrowLeft size={16} /> 戻る
          </button>
        </div>
      </header>

      <main className="max-w-[800px] mx-auto px-5 py-7">
        <div className="card">
          <h3 className="text-lg font-bold mb-2">お問い合わせ</h3>
          <p className="text-sm text-soft mb-6">ご質問・ご要望・不具合報告などお気軽にどうぞ。</p>

          <label className="field-label">お名前</label>
          <input type="text" value={form.name} placeholder="山田 太郎"
            onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
            className="input-field mb-4" />

          <label className="field-label">メールアドレス</label>
          <input type="email" value={form.email} placeholder="example@mail.com"
            onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
            className="input-field mb-4" />

          <label className="field-label">カテゴリ</label>
          <select value={form.category}
            onChange={(e) => setForm((p) => ({ ...p, category: e.target.value }))}
            className="select-field mb-4">
            <option>一般的な質問</option>
            <option>機能のリクエスト</option>
            <option>不具合の報告</option>
            <option>アカウントについて</option>
            <option>個人情報について</option>
            <option>その他</option>
          </select>

          <label className="field-label">お問い合わせ内容</label>
          <textarea value={form.message} placeholder="お問い合わせ内容を入力してください"
            onChange={(e) => setForm((p) => ({ ...p, message: e.target.value }))}
            className="input-field mb-4" rows={6}
            style={{ resize: "vertical", fontFamily: "inherit" }} />

          {result && (
            <div className={`text-sm mb-4 ${result.includes("ありがとう") ? "text-income" : "text-expense"}`}>
              {result}
            </div>
          )}

          <button onClick={handleSubmit} disabled={sending}
            className="btn-primary flex items-center justify-center gap-2">
            {sending ? <Loader size={16} className="animate-spin" /> : <Send size={16} />}
            {sending ? "送信中..." : "送信する"}
          </button>
        </div>
      </main>
    </div>
  );
};

export default ContactPage;